import { loadScriptAsynchronously } from "client/Hooks";
import { SibiUserIntegrationModel, userConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import "./Sibi.less";

let _wasInitialize = false;

export function initSibiPop(): void {
	if (_wasInitialize) {
		return;
	}

	_wasInitialize = true;

	const { sibi } = userConfiguration();

	if (!sibi) {
		return;
	}

	initialize(sibi);
}

// This is our own version of the "Sibi POP! Snippet" (https://workspace-365.acceptatie.sibi.nl/beheer/partners/23/bekijken)
async function initialize(sibi: SibiUserIntegrationModel): Promise<void> {
	try {
		const cacheBustValue: string = new Date()
			.getTime()
			.toString()
			.substring(0, 5);

		const tenantUrl: string = `https://${sibi.subdomain}.sibi.nl`;
		const scriptUrl: string = tenantUrl + `/pop/widget.js?cache=${cacheBustValue}`;
		await loadScriptAsynchronously(scriptUrl);

		(window as any)
			.SibiPop.init(tenantUrl, sibi.employeeReference);
	} catch (e) {
		console.error("Failed to integrate with Sibi", e);
	}
}
